<script setup lang="ts">
import RoutingChoicesPage from '../features/routing-choices/RoutingChoicesPage.vue';
</script>

<template>
  <RoutingChoicesPage />
</template>
